<template>
    <div class="max-w-screen-xl mx-auto mt-24 p-4">
        <div class="grid grid-cols-12 md:gap-x-8 gap-y-8">
            <div class="2xl:col-span-3 xl:col-span-4 md:col-span-6 col-span-12 h-full drop-shadow-xl bg-white"
                v-for="article in articles">
                <div class="w-full rounded-lg overflow-hidden h-full">
                    <div class="xl:h-36 lg:h-44 h-60 flex-shrink-0 overflow-hidden">
                        <nuxt-img loading="lazy" :src="article.image" format="webp" class="object-cover min-h-full min-w-full" :alt="article.title" />
                    </div>
                    <div class="p-6 ">
                        <h2 class="xl:text-xl text-lg mb-3 font-semibold">
                            {{ article.title }}
                        </h2>
                        <p class="text-base">
                            {{ article.description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
export default defineComponent({
    props: {
        articles: {
            type: Array<{
                title: string
                description: string
                image?: string
            }>,
            default: []
        }
    }
})
</script>